<template>
  <div>
    <b-card title="Datos del usuario">
      <b-row>
        <b-col md="6">
          <b-col>
            <b-form-group label="ID" label-for="id">
              <b-form-input id="id" v-model="user.id" disabled />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Código" label-for="code">
              <b-form-input id="code" v-model="user.code" disabled />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="6">
          <b-col>
            <b-form-group label="Valor" label-for="value">
              <b-form-input id="value" v-model="user.value" type="number"/>
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit and reset -->
        <b-col>
          <div>
            <b-button variant="primary" @click="sendData">
              <feather-icon icon="SaveIcon" class="mr-50" />
              <span class="align-middle">Guardar cambios</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import axiosIns from '../../../../../../libs/axios'
import moment from 'moment'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
  },

  data() {
    return {
      isLoading: false,
      user: {},
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const { id } = jsonUserData
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    async fetchData() {
      this.isLoading = true
      try {
        const id = this.$route.params.id
        const response = await axiosIns.get(`/nomina/incrementals/${id}/`)
        this.user = response.data
        this.user.clonned_date = this.user.clonned_date ? moment(this.user.clonned_date).format('DD/MM/YY h:mm:ss A') : '-'
        this.user.presented_date = this.user.presented_date ? moment(this.user.presented_date).format('DD/MM/YY h:mm:ss A') : '-'
        this.isLoading = false
      } catch (error) {
        console.error('Error:', error)
        this.isLoading = false
      }
    },
    async sendData() {
      this.isLoading = true
      try {
        const id = this.$route.params.id
        delete this.user.id
        delete this.user.code
        const response = await axiosIns.put(`/nomina/incrementals/${id}/`, this.user)
        if (response && response.status === 200) {
          this.isLoading = false
          this.fetchData()
          this.$swal({
            icon: 'success',
            title: '¡Guardado!',
            text: 'La información ha sido actualizada',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        } else {
          this.printErrorModal('Error en el servidor')
        }
      } catch (error) {
        console.error('Error:', error)
        this.isLoading = false
      }
    },
  },
}
</script>
